<ng-container
  *transloco="let t; prefix: 'financing.reasons-to-choose-financing-section'"
>
  <div class="mb-10">
    <h3 class="text-black rfs:text-4xl mb-6">
      {{ t("title") }}
    </h3>
    <p class="text-gray-800 mt-6 mb-10">
      {{ t("text") }}
    </p>
  </div>
  <div class="grid lg:grid-cols-2 gap-10">
    @for (item of cardItems; track item) {
    <div class="bg-white rounded-small p-8 col-span-2 lg:col-span-1">
      <div class="mb-5">
        <img [src]="item.imgPath" alt="" class="object-fit h-[80px]" />
      </div>
      <div class="flex flex-col gap-2">
        <h3 class="rfs:text-2xl text-black">{{ t(item.title) }}</h3>
        <p class="text-gray-700">{{ t(item.text) }}</p>
      </div>
    </div>
    }
  </div>
</ng-container>
